// Module
var code = "<a href=\"/academy/tag/<%- tag %>-<%- id %>\" class=\"badge badge-info badge-inline text-capitalize\"><%- tag %></a> ";
// Exports
module.exports = code;